import { LLM_RESOURCES, STATIC_TEXT_EVENT_MAPPING } from "@limitless/common/apis/resource-api/RemoteResourceUtil";
import { ClientContext } from "@limitless/common/utils";

export const getLLMResources = hiwSet => {
    const llmResourceList = LLM_RESOURCES;

    //if we're in reach out mode, try and get an extra resource, should do the same with HIW cards too :)
    if (ClientContext._reachOutMode !== "none") {
        llmResourceList.push(STATIC_TEXT_EVENT_MAPPING);
    }

    if (hiwSet === "" || typeof hiwSet === "number") {
        llmResourceList.map(res => {
            if (res.stateKey === "hiwSlides") {
                res.name = `llm_how_it_works${hiwSet}.json`;
            }
        });
    }

    return llmResourceList;
};
